// summary-clickable.js (improved)
// Behavior:
// - Click summary: opens submenu (no navigation).
// - Second click within SHORT window navigates, but only if a clear target URL is found.
// - Priority for target URL:
//     1) details[data-href]
//     2) a page link on the page whose visible text matches the summary label (exact trimmed match)
//     3) (FALLBACK) first link inside submenu ONLY if an explicit match wasn't found AND fallbackAllowed = true
//
// By default fallbackAllowed is false to avoid accidental navigation to child items.

(function () {
  var NAV_ROOT = '.header__inline-menu';
  var SECOND_CLICK_MS = 700;
  var fallbackAllowed = false; // set true to allow fallback to first submenu item (not recommended)

  function isCaret(el) {
    return !!el.closest && !!el.closest('.icon-caret, .icon-arrow, svg.icon-caret, svg.icon-arrow');
  }

  function findMatchingLinkByText(text) {
    if (!text) return null;
    // Normalize text
    var targetText = text.trim().replace(/\s+/g, ' ').toLowerCase();
    var candidates = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
    // look for an anchor whose visible text equals targetText
    for (var i = 0; i < candidates.length; i++) {
      var a = candidates[i];
      var t = (a.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
      if (t === targetText) return a;
    }
    // try partial startsWith (only if exact not found)
    for (var j = 0; j < candidates.length; j++) {
      var a2 = candidates[j];
      var t2 = (a2.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
      if (t2 && (t2.indexOf(targetText) === 0 || targetText.indexOf(t2) === 0)) return a2;
    }
    return null;
  }

  function findPrimaryLink(detailsEl) {
    if (!detailsEl) return null;
    // 1) data-href on details (explicit)
    var dh = detailsEl.getAttribute('data-href');
    if (dh && dh.trim()) return { href: dh.trim(), element: null };

    // 2) try to match link by visible text of the summary
    var summary = detailsEl.querySelector(':scope > summary');
    var labelText = '';
    if (summary) {
      // prefer the span or text node inside summary
      var span = summary.querySelector('span');
      labelText = span ? (span.textContent || '') : (summary.textContent || '');
      // remove caret text if present
      // trim excessive whitespace
      labelText = (labelText || '').replace(/\s+/g, ' ').trim();
    }
    if (labelText) {
      var match = findMatchingLinkByText(labelText);
      if (match) return { href: match.getAttribute('href'), element: match };
    }

    // 3) fallback to first link inside submenu only if allowed
    if (fallbackAllowed) {
      var first = detailsEl.querySelector(':scope > .header__submenu a[href], :scope a[href]');
      if (first) {
        return { href: first.getAttribute('href'), element: first };
      }
    }

    // nothing clear found
    return null;
  }

  function onClick(e) {
    var root = e.target.closest && e.target.closest(NAV_ROOT);
    if (!root) return;

    var summary = e.target.closest && e.target.closest(NAV_ROOT + ' details > summary, ' + NAV_ROOT + ' summary');
    if (!summary) return;

    if (isCaret(e.target)) {
      // caret icon clicked — leave default toggle behavior
      return;
    }

    var details = summary.closest('details');
    if (!details) return;

    var targetInfo = findPrimaryLink(details);

    // If there's no explicit target and fallback disallowed, just toggle/open and return
    if (!targetInfo) {
      // open the submenu (default behavior), but ensure it's open
      details.open = true;
      // don't navigate to any child link
      e.preventDefault();
      return;
    }

    var href = (targetInfo.href || '').trim();
    if (!href || href === '#' || href.indexOf('javascript:') === 0) {
      details.open = true;
      e.preventDefault();
      return;
    }

    // If modifier keys or middle-click: open in new tab/window
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
      window.open(href, '_blank');
      e.preventDefault();
      return;
    }

    // If details already open -> navigate immediately to the target href
    if (details.open) {
      window.location.href = href;
      e.preventDefault();
      return;
    }

    // details is closed -> open it and store timestamp for second click navigation
    details.open = true;
    details.__summaryClickedAt = Date.now();

    var handler = function (clickEvent) {
      if (isCaret(clickEvent.target)) return;
      var now = Date.now();
      if (details.__summaryClickedAt && (now - details.__summaryClickedAt) <= SECOND_CLICK_MS) {
        var mod = clickEvent.ctrlKey || clickEvent.metaKey || clickEvent.shiftKey || clickEvent.button === 1;
        if (mod) {
          window.open(href, '_blank');
        } else {
          window.location.href = href;
        }
        clickEvent.preventDefault();
      }
      details.__summaryClickedAt = null;
      document.removeEventListener('click', handler, true);
    };

    document.addEventListener('click', handler, true);
    setTimeout(function () {
      details.__summaryClickedAt = null;
      document.removeEventListener('click', handler, true);
    }, SECOND_CLICK_MS + 50);

    e.preventDefault();
  }

  // Use capture so we get clicks before other handlers
  document.addEventListener('click', onClick, true);
})();
